var disposed = false
var Component = require("!../../node_modules/.12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/.12.2.2@vue-loader/lib/selector?type=script&index=0!./message.vue"),
  /* template */
  require("!!../../node_modules/.12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-e6c2c0a2\",\"hasScoped\":false}!../../node_modules/.12.2.2@vue-loader/lib/selector?type=template&index=0!./message.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "E:\\node_pro\\vue-component-elementUI\\message\\src\\components\\message.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] message.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e6c2c0a2", Component.options)
  } else {
    hotAPI.reload("data-v-e6c2c0a2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/message.vue
// module id = 9
// module chunks = 0